import { answerEnglishIqV2Api, type EnglishIqResponseV2Type } from '@repo/sdk';
import { requireEnglishIqResponseData } from '../../actions/require-english-iq-response-data';

interface IAnswerEnglishIqV2WebSessionParams {
  idempotencyId: string;
  itemId: string;
  replayCount: number;
  response: EnglishIqResponseV2Type;
  responseTimeMs: number;
  token: string;
}

export async function answerEnglishIqV2WebSession(params: IAnswerEnglishIqV2WebSessionParams) {
  const response = await answerEnglishIqV2Api(params);
  return requireEnglishIqResponseData(response.data.data);
}
